<template>
  <card :plain="isEmbeddedInModal">
    <slot name="header">
      <h4 class="title text-center">
        New Contact
      </h4>
      <span v-if="validationError === true" class="validationErrorText">
        <p>Missing fields.</p>
        <p v-if="notParishAlumni && !isAdmin">
          Make sure first name, last name, Varsity Catholic, Greek, school year, and gender are filled out.
        </p>
        <p v-else>Make sure first name, last name, and gender are filled out.</p>
      </span>
    </slot>
    <div>
      <div class="row">
        <div
          :class="{
            'col-md-6': !isEmbeddedInModal,
            'col-md-12': isEmbeddedInModal
          }"
        >
          <fg-input
            type="text"
            label="First Name"
            placeholder="First Name"
            v-model="first_name"
            required
          />
        </div>
        <div
          :class="{
            'col-md-6': !isEmbeddedInModal,
            'col-md-12': isEmbeddedInModal
          }"
        >
          <fg-input
            type="text"
            label="Last Name"
            placeholder="Last Name"
            v-model="last_name"
            required
          />
        </div>
      </div>
      <div class="row">
        <div
          :class="{
            'col-md-6': !isEmbeddedInModal,
            'col-md-12': isEmbeddedInModal,
            'col-form-label': true
          }"
        >
          <fg-input
            type="text"
            label="Email (non .edu)"
            placeholder="Email"
            v-model="email"
          />
        </div>
        <div
          :class="{
            'col-md-6': !isEmbeddedInModal,
            'col-md-12': isEmbeddedInModal,
            'col-form-label': true
          }"
        >
          <fg-input
            type="text"
            label="Email (optional .edu)"
            placeholder="Email"
            v-model="email2"
          />
        </div>
        <div
          :class="{
            'col-md-6': !isEmbeddedInModal,
            'col-md-12': isEmbeddedInModal
          }"
        >
          <fg-input
            type="text"
            label="Phone"
            placeholder="Phone"
            v-model="phone"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="control-label">
            Gender
            <span class="text-danger">*</span>
          </label>
          <fg-input>
            <el-select
              class="select-default"
              size="large"
              placeholder="Gender"
              v-model="gender_id"
              filterable
            >
              <el-option
                v-for="genderOption in genderOptions"
                class="select-default"
                :key="genderOption.id"
                :label="genderOption.name"
                :value="genderOption.id"
              />
            </el-select>
          </fg-input>
        </div>
        <div
          class="col-md-6"
          v-if="notParishAlumni"
        >
          <label class="control-label">
            School Year
            <span v-if="notParishAlumni" class="text-danger">*</span>
          </label>
          <fg-input>
            <el-select
              class="select-default"
              size="large"
              placeholder="School Year"
              v-model="school_year_id"
              filterable
            >
              <el-option
                v-for="schoolYearOption in schoolYearOptions"
                class="select-default"
                :key="schoolYearOption.id"
                :label="schoolYearOption.name"
                :value="schoolYearOption.id"
              />
            </el-select>
          </fg-input>
        </div>
      </div>
      <div
        class="row"
        v-if="notParishAlumni"
      >
        <div class="col-sm-6">
          <label>
            Does this person play a varsity sport?
            <span v-if="notParishAlumni" class="text-danger">*</span>
          </label>
          <p-radio
            v-model="is_varsity"
            :value="1"
            :label="true"
          >
            Yes
          </p-radio>
          <p-radio
            v-model="is_varsity"
            :value="0"
            :label="false"
          >
            No
          </p-radio>
        </div>
        <div class="col-sm-6">
          <label>
            Is this person in a fraternity or sorority?
            <span v-if="notParishAlumni" class="text-danger">*</span>
          </label>
          <p-radio
            v-model="is_greek"
            :value="1"
            :label="true"
          >
            Yes
          </p-radio>
          <p-radio
            v-model="is_greek"
            :value="0"
            :label="false"
          >
            No
          </p-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" v-if="person && isOneOfTheseRoles(['admin', 'superadmin'])">
          <label class="control-label">Role</label>
          <fg-input>
            <el-select
              class="select-default"
              size="large"
              placeholder="Role"
              v-model="role_id"
              filterable
            >
              <el-option
                v-for="roleOption in roleOptions"
                class="select-default"
                :key="roleOption.id"
                :label="roleOption.title"
                :value="roleOption.id"
              />
            </el-select>
          </fg-input>
        </div>
        <div class="col-md-6" v-if="person && isOneOfTheseRoles(['admin', 'superadmin'])">
          <label class="control-label">Location</label>
          <fg-input>
            <el-select
              class="select-default"
              size="large"
              placeholder="Location"
              v-model="location_id"
              filterable
            >
              <el-option
                v-for="locationOption in locationOptions"
                class="select-default"
                :key="locationOption.id"
                :label="locationOption.name"
                :value="locationOption.id"
              />
            </el-select>
          </fg-input>
        </div>
      </div>
      <div>
        <label class="control-lable">My notes</label>
        <el-input
          type="textarea"
          placeholder="Notes"
          v-model="user_notes_on_person"
        />
      </div>
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-info btn-fill btn-wd"
          v-if="!saving"
          @click="handleSave()"
        >
          Save Contact
        </button>
        <button type="submit" class="btn btn-info btn-fill btn-wd" v-if="saving">
          Saving...
        </button>
      </div>
    </div> <!-- card body -->
  </card>
</template>
<script>
import {
    mapState
} from 'vuex';

function validateForm(notParishAlumni, isAdmin, firstName, lastName, genderId, schoolYearId, isVarsity, isGreek) {
    if (notParishAlumni && !isAdmin) {
        return !!firstName && !!lastName && !!genderId && !!schoolYearId && isVarsity !== '' && isGreek !== '';
    }
    // Else is parish/alumni
    return !!firstName && !!lastName && !!genderId;
}

export default {
    data() {
        return {
            namespace: 'People',
            first_name: '',
            last_name: '',
            email: '',
            email2: '',
            phone: '',
            gender_id: '',
            school_year_id: '',
            is_varsity: '',
            is_greek: '',
            user_notes_on_person: null,
            validationError: false,
            saving: false,
            role_id: '',
            location_id: '',
        };
    },
    props: {
        isEmbeddedInModal: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            genderOptions: (state) => state.People.genders,
            schoolYearOptions: (state) => state.People.schoolYears,
            person: (state) => state.People.person,
            roleOptions: (state) => state.People.roles,
            locationOptions: (state) => state.People.locations
        }),
        notParishAlumni() {
            return !this.isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])
              || this.isOneOfTheseRoles(['admin']);
        },
        isAdmin() {
            return this.isOneOfTheseRoles(['admin']);
        }
    },
    methods: {
        handleSave() {
            this.saving = true;
            this.validationError = false;
            if (!validateForm(this.notParishAlumni, this.isAdmin, this.first_name, this.last_name, this.gender_id,
                this.school_year_id, this.is_varsity, this.is_greek)) {
                this.validationError = true;
                this.saving = false;
                return;
            }
            this.$store.dispatch(`${this.namespace}/storePerson`, {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email ? this.email.toLowerCase() : '',
                email2: this.email2 ? this.email2.toLowerCase() : '',
                phone: this.phone,
                gender_id: this.gender_id,
                school_year_id: this.school_year_id,
                is_varsity: this.is_varsity,
                is_greek: this.is_greek,
                user_notes_on_person: this.user_notes_on_person,
                role_id: this.role_id,
                location_id: this.location_id
            })
                .then((personId) => {
                    this.saving = false;
                    if (this.isEmbeddedInModal) {
                        const savedPerson = {
                            id: personId,
                            name: `${this.first_name} ${this.last_name}`
                        };
                        this.$emit('savedPerson', savedPerson);
                    } else {
                        this.$router.push({ name: 'PersonShow', params: { id: personId } });
                    }
                }).catch((error) => {
                    this.error = error;
                    this.$message(error.response.data.message);
                    this.saving = false;
                });
        },
        clearInputs() {
            this.first_name = '';
            this.last_name = '';
            this.email = '';
            this.email2 = '';
            this.phone = '';
            this.gender_id = '';
            this.school_year_id = '';
            this.is_varsity = '';
            this.is_greek = '';
            this.validationError = false;
            this.saving = false;
            this.role_id = '';
            this.location_id = '';
        },
        getGenders() {
            this.$store.dispatch(`${this.namespace}/getGenders`);
        },
        getSchoolYears() {
            this.$store.dispatch(`${this.namespace}/getSchoolYears`);
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        getLocations() {
            this.$store.dispatch(`${this.namespace}/getLocations`);
        },
        getRoles() {
            this.$store.dispatch(`${this.namespace}/getRoles`);
        },
    },
    created() {
        this.getGenders();
        this.getSchoolYears();
    },
    mounted() {
        this.getRoles();
        this.getLocations();
    },

};
</script>
